export default function GaleriaCafeteriaSection() {
  const imagenes = [
    {
      id: 1,
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/d92534b5c02ec51aafe6d53f0ab2e979.jpeg',
      alt: 'Equipo de Nero Nobile en la barra'
    },
    {
      id: 2,
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/76615ef682809e891c68441a23393110.jpeg',
      alt: 'Interior acogedor del hostal'
    },
    {
      id: 3,
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/a4dc68330ace5c1350c3f4c48b113325.jpeg',
      alt: 'Facturas y pastelería artesanal'
    },
    {
      id: 4,
      url: 'https://public.readdy.ai/ai/img_res/cdf55f44bdbb717c6d4a86820500fce4.jpg',
      alt: 'Preparación de café de especialidad'
    },
    {
      id: 5,
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/f119d8a1c6a952ee1ab8074cc92e4551.jpeg',
      alt: 'Batido con crema y galletas Oreo'
    },
    {
      id: 6,
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/6a6ca58d60aaaf9a7a09bb9570a65737.jpeg',
      alt: 'Carteles vintage de café en pared de madera'
    }
  ];

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-stone-800 mb-4">
            Nuestra Cafetería
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Un espacio cálido inspirado en la Patagonia
          </p>
        </div>

        {/* Grid de Fotos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {imagenes.map((imagen, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500"
            >
              <div className="w-full h-80 overflow-hidden bg-stone-100">
                <img
                  src={imagen.url}
                  alt={imagen.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
